import React, { useEffect, useRef, useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Environment } from 'src/Environment';
import Faqs from '../faqs/faqs';
import QualificationBox from '../qualification-box/qualification-box';
import QualificationSideScroll from '../qualification-side-scroll/qualification-side-scroll';
import { paymentsDashboardRoute } from 'src/routing/routes';
import { MerchantProfileContext } from 'src/context/merchant-profile-context';
import Disclaimer from '../disclaimer/disclaimer';
import TealiumEvents from 'src/helpers/tealium-events';
import HeaderNav from '../../header-nav/header-nav';

const faqs = [
  {
    title: "Why don't I qualify for a Business Cash Advance?",
    text: "Unfortunately, you don't qualify if you fail to meet the criteria stipulated below.",
    bulletPoints: [
      'Your business must be operational for at least three months',
      'You must earn a minimum of R3 000 a month',
      'You must process a minimum of 10 transactions on your POS device daily',
    ],
  },
  {
    title: 'Why do I need to process a minimum of 10 transactions a month?',
    text: 'When you take a Business Cash Advance, we take a portion of the daily transaction value on your POS device to settle your Business Cash Advance.',
  },
  {
    title: 'How long should I wait before I apply for a Business Cash Advance?',
    text: 'You will be informed through the portal the moment you qualify and can apply at any time thereafter, as long as you still meet the qualifying criteria.',
  },
];

export default function BusinessCashAdvanceNoQualify() {
  const topOfPage = useRef('top');
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false);

  const { merchant } = useContext(MerchantProfileContext);

  useEffect(() => {
    TealiumEvents.getFinancedBCANoQualMoreInfo();
    if (topOfPage.current) {
      topOfPage.current.scrollIntoView(false);
    }
  }, []);

  // TODO: BCA Flag to be removed
  if (Environment.current?.disabledFeatures?.bca) {
    return <Redirect push to={paymentsDashboardRoute} />;
  }
  return (
    <div className="BusinessCashAdvanceNoQualify">
      <HeaderNav
        title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
        screenName="Business Cash Advance"
      >
        {showDisclaimerModal && <Disclaimer setShow={setShowDisclaimerModal} />}
        <h1
          className="page-title is-hidden-mobile"
          automationid="Business_Cash_Advance_No_Qualify_H1_Heading"
          ref={topOfPage}
        >
          Business Cash Advance
        </h1>
        <h1 className="secondary-title mobile-centered is-hidden-mobile">Minimum Criteria:</h1>
        <h1 className="secondary-title mobile-centered is-hidden-tablet has-margin-top-0">
          Minimum Criteria
        </h1>
        <QualificationSideScroll automationIdPrefix="Business_Cash_Advance_No_Qualify_QualificationSideScroll">
          <QualificationBox
            qualificationTitle="Operating period"
            qualificationSubTitle="You've been trading for at least"
            qualificationMeasure="4 months"
            automationIdPrefix="Business_Cash_Advance_No_Qualify_QualificationBox_Operating_Period"
          />
          <QualificationBox
            qualificationTitle="Turnover"
            qualificationSubTitle="Your business makes more than"
            qualificationMeasure="R 3000.00"
            automationIdPrefix="Business_Cash_Advance_No_Qualify_QualificationBox_Turnover"
          />
          <QualificationBox
            qualificationTitle="Minimum payment transactions"
            qualificationSubTitle="Your terminals process more than"
            qualificationMeasure="10 payments"
            automationIdPrefix="Business_Cash_Advance_No_Qualify_QualificationBox_Minimum_Payment_Transactions"
          />
        </QualificationSideScroll>
        <Faqs
          faqs={faqs}
          automationIdPrefix="Business_Cash_Advance_No_Qualify_Faqs"
          faqOnClick={(topic) => TealiumEvents.infoPageBCAClickFAQ(topic)}
        />
        <div className="disclaimer">
          <span className="disclaimer-title">Disclaimer</span>
          <br />
          <span className="disclaimer-subtitle">
            By selecting 'View offer', you agree to the Vodacom{' '}
            <span
              className="is-red-text-link"
              automationid="BCA_Link_Disclaimer"
              onClick={() => {
                TealiumEvents.infoPageBCAClickDisclaimerLink('');

                setShowDisclaimerModal(true);
              }}
            >
              disclaimer
            </span>
            .
          </span>
        </div>
      </HeaderNav>
    </div>
  );
}
